import { findNavigationMatch } from '../../helpers/findNavigationMatch'
import type { BreadcrumbItem, NavigationGroup } from '../../../types'

const RECORD_ACTION_LABELS: Readonly<Record<string, string>> = {
  edit: 'Edit',
  delete: 'Delete',
}

export function buildBreadcrumbTrail(
  groups: readonly NavigationGroup[],
  pathname: string
): BreadcrumbItem[] {
  const match = findNavigationMatch(groups, pathname)
  if (!match) {
    return []
  }

  const { group, item } = match
  const recordSegments = pathname
    .slice(item.to.length)
    .split('/')
    .filter(Boolean)
  if (recordSegments.length === 0) {
    return [{ label: group.label }, { label: item.label }]
  }

  const sectionTrail: BreadcrumbItem[] = [
    { label: group.label },
    { label: item.label, to: item.to },
  ]
  if (recordSegments[0] === 'create') {
    return [
      ...sectionTrail,
      { label: `New ${item.singularLabel ?? item.label}` },
    ]
  }

  const lastSegment = recordSegments[recordSegments.length - 1]
  const recordActionLabel = RECORD_ACTION_LABELS[lastSegment]
  if (!recordActionLabel) {
    return [...sectionTrail, { label: 'Details' }]
  }

  const detailPath = pathname.slice(0, pathname.length - lastSegment.length - 1)
  return [
    ...sectionTrail,
    { label: 'Details', to: detailPath },
    { label: recordActionLabel },
  ]
}
